/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Move_StageInputs */

const cs_deals_move_stage = /** @type {(inputs: Deals_Move_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout do fáze`)
};

const en_deals_move_stage = /** @type {(inputs: Deals_Move_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to stage`)
};

/**
* | output |
* | --- |
* | "Move to stage" |
*
* @param {Deals_Move_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_move_stage = /** @type {((inputs?: Deals_Move_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Move_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_move_stage(inputs)
	return cs_deals_move_stage(inputs)
});